export const scripts = {}
export const scriptLoadInit = 'SCRIPT_LOAD_INIT'
export const scriptLoadSuccess = 'SCRIPT_LOAD_SUCCESS'
export const scriptLoadFail = 'SCRIPT_LOAD_FAIL'
